import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { StorageService } from '../../core/storage/storageService';
import { UIFeedback } from './uiFeedback';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(
    private api: GatewayAPIService,
    private storage: StorageService,
  ) {}

  public postFeedback(feedback: Partial<UIFeedback>): Promise<void> {
    return this.post(feedback);
  }

  post(feedback: Partial<UIFeedback>): Promise<void> {
    return this.api.apiCallSane(
      '/feedback',
      'POST',
      this.api.getDefaultHeaders(),
      null,
      feedback,
      this.options,
    );
  }
}
